import {Action, OperationType} from "puzzle";

export const reloadHelp: Action = [{
  name: 'userPromise',
  type: OperationType.action
}];
